// TODO: Extract full content from App.js renderTabContent case 'mission'
// This is a placeholder - needs full extraction from lines 860-1065
import React from 'react';
import { useTranslation } from 'react-i18next';
import ParticleAnimation from '../animations/ParticleAnimation';

const MissionPage = () => {
  const { t } = useTranslation();

  return (
    <div className="content-section mission-section">
      <h2 className="mission-title">{t('mission.title.our')} <span className="gradient-text">{t('mission.title.mission')}</span></h2>
      
      <div className="mission-hero">
        <div className="mission-tagline">
          <p>{t('mission.tagline')}</p>
        </div>
      </div>
      
      <div className="mission-layout">
        <div className="mission-content">
          <div className="mission-statement-container">
            <p className="mission-statement">
              {t('mission.statement')}
            </p>
          </div>
          
          <div className="mission-pillars-container">
            <div className="mission-pillars">
              <div className="mission-card ai-powered">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h3>{t('mission.cards.ai.title')}</h3>
                <div className="card-content">
                  <p>
                    {t('mission.cards.ai.paragraph1.before')} <span className="highlight">{t('mission.cards.ai.paragraph1.highlight')}</span> {t('mission.cards.ai.paragraph1.after')}
                  </p>
                  <p>
                    {t('mission.cards.ai.paragraph2.before')} <span className="highlight">{t('mission.cards.ai.paragraph2.highlight')}</span> {t('mission.cards.ai.paragraph2.after')}
                  </p>
                  <div className="tech-badge-container">
                    <span className="tech-badge">{t('mission.cards.ai.badges.llm')}</span>
                    <span className="tech-badge">{t('mission.cards.ai.badges.neural')}</span>
                    <span className="tech-badge">{t('mission.cards.ai.badges.sentiment')}</span>
                  </div>
                </div>
              </div>
              
              <div className="mission-card-with-animation">
                <div className="mission-card investment-horizon">
                  <div className="card-icon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3>{t('mission.cards.horizon.title')}</h3>
                  <div className="card-content">
                    <p>
                      {t('mission.cards.horizon.paragraph1.before')} <span className="highlight">{t('mission.cards.horizon.paragraph1.highlight1')}</span> {t('mission.cards.horizon.paragraph1.middle')} <span className="highlight">{t('mission.cards.horizon.paragraph1.highlight2')}</span>{t('mission.cards.horizon.paragraph1.after')}
                    </p>
                    <p>
                      {t('mission.cards.horizon.paragraph2')}
                    </p>
                    
                    <div className="strategy-spectrum">
                      <div className="strategy-point">
                        <span className="point-marker"></span>
                        <span className="point-label">{t('mission.cards.horizon.strategies.dayTrading')}</span>
                      </div>
                      <div className="strategy-line"></div>
                      <div className="strategy-point">
                        <span className="point-marker"></span>
                        <span className="point-label">{t('mission.cards.horizon.strategies.swingTrading')}</span>
                      </div>
                      <div className="strategy-line"></div>
                      <div className="strategy-point">
                        <span className="point-marker"></span>
                        <span className="point-label">{t('mission.cards.horizon.strategies.shortTerm')}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="mission-card transparency">
                <div className="card-icon">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                
                <h3>{t('mission.cards.workflow.title')}</h3>
                <div className="workflow-container">
                  <div className="workflow-step">
                    <div className="step-number">01</div>
                    <div className="step-content">
                      <h4>{t('mission.cards.workflow.steps.step1.title')}</h4>
                      <p>{t('mission.cards.workflow.steps.step1.description')}</p>
                    </div>
                  </div>
                  
                  <div className="workflow-connector">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                
                  <div className="workflow-step">
                    <div className="step-number">02</div>
                    <div className="step-content">
                      <h4>{t('mission.cards.workflow.steps.step2.title')}</h4>
                      <p>{t('mission.cards.workflow.steps.step2.description')}</p>
                    </div>
                  </div>
                  
                  <div className="workflow-connector">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  
                  <div className="workflow-step">
                    <div className="step-number">03</div>
                    <div className="step-content">
                      <h4>{t('mission.cards.workflow.steps.step3.title')}</h4>
                      <p>{t('mission.cards.workflow.steps.step3.description')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mission-animation-container">
          <div className="mission-animation">
            <ParticleAnimation />
          </div>
          <div className="animated-metrics">
            <div className="animated-metric">
              <div className="metric-title">{t('mission.metrics.markets.title')}</div>
              <div className="metric-value counter" data-target="14" data-increment="1">14</div>
            </div>
            <div className="animated-metric">
              <div className="metric-title">{t('mission.metrics.dataPoints.title')}</div>
              <div className="metric-value">10k+</div>
            </div>
            <div className="animated-metric">
              <div className="metric-title">{t('mission.metrics.agents.title')}</div>
              <div className="metric-value">6103</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="future-vision">
        <h3>{t('mission.future.title')}</h3>
        <p>
          {t('mission.future.description')}
        </p>
        <div className="video-link-container">
          <a 
            href="https://www.youtube.com/playlist?list=PLuLQVRd0_U92SUQcFd-d4EzJT8Cv6tKhY" 
            target="_blank" 
            rel="noopener noreferrer"
            className="video-playlist-link"
          >
            <span className="video-icon">▶️</span>
            <span className="video-link-text">{t('mission.future.watchSeries')}</span>
          </a>
        </div>
      </div>

      {/* Counter Animation Script */}
      <script dangerouslySetInnerHTML={{
        __html: `
          (function() {
            const counters = document.querySelectorAll('.counter');
            counters.forEach(counter => {
              const target = parseInt(counter.getAttribute('data-target'));
              const increment = parseInt(counter.getAttribute('data-increment'));
              let current = 0;
              
              const updateCounter = () => {
                if (current < target) {
                  current += increment;
                  if (current > target) current = target;
                  
                  if (target >= 1000) {
                    counter.textContent = current >= 1000 ? (current / 1000).toFixed(0) + 'k+' : current;
                  } else {
                    counter.textContent = current;
                  }
                  
                  setTimeout(updateCounter, 50);
                }
              };
              
              updateCounter();
            });
          })();
        `
      }} />
    </div>
  );
};

export default MissionPage;
